export default "<img #img\n     draggable=\"false\"\n     (load)=\"onload()\"\n     [src]=\"image.image\"\n     (error)=\"getDefault($event)\"\n/>\n";